import React from 'react'

export const Footer = () => {
  return (
    <footer className='footer'>
        Portafolio Oswaldo Gonzalez &copy; Maester en React - 2023
    </footer>
  )
}
